import React, { Component } from 'react'

import { PayPalButton } from "react-paypal-button-v2";

export default class PaySubBtn extends Component {
    constructor(props) {
        super(props)

        // get from build product plan id [in business account]
        this.planId = process.env.REACT_APP_PAYPAL_PLAN_ID

        // app rest api key [in user account "App and credential"]
        this.paypalKey = process.env.REACT_APP_PAYPAL_KEY

        this.amount = 1
        this.currency = "USD"
    }

    paypalSubscribe = (data, actions) => {
        return actions.subscription.create({
            'plan_id': this.planId,
        });
    };

    componentDidMount() { }
    render() {
        return (
            <div>
                <PayPalButton
                    amount={this.amount}
                    currency={this.currency}
                    createSubscription={(data, details) => this.paypalSubscribe(data, details)}
                    onApprove={(data, details) => this.props.onApprove(data, details)}
                    onError={(err) => this.props.onError(err)}
                    catchError={(err) => this.props.catchError(err)}
                    onCancel={(err) => this.props.onCancel(err)}
                    options={{
                        clientId: this.paypalKey,
                        vault: true
                    }}
                    style={{
                        shape: 'rect',
                        color: 'blue',
                        layout: 'vertical',
                        label: 'subscribe',
                    }}
                />
            </div>
        )
    }
}
